export interface IOrderProductItem {
    scheduleId?: number;
    productName?: string;
    quantity?: number;
    cprcode: number;
    originalPrice?: number;
    price?: number;
    rowTotal?: number;
    remark?: string;
    isPreOrder?: boolean;
    productBrand?: string;
}

export class OrderProductItem implements IOrderProductItem {
    scheduleId?: number;
    productName = "";
    quantity = 0;
    cprcode: number;
    originalPrice?: number;
    price?: number;
    rowTotal?: number;
    remark?: string;
    isPreOrder = false;
    productBrand?: string;

    constructor(data: IOrderProductItem) {
        this.scheduleId = data.scheduleId
        if (data.productName) {
            this.productName = data.productName
        }
        if (data.quantity) {
            this.quantity = data.quantity
        }
        this.cprcode = data.cprcode
        this.originalPrice = data.originalPrice
        this.price = data.price
        this.rowTotal = data.rowTotal
        this.remark = data.remark
        if (data.isPreOrder) {
            this.isPreOrder = data.isPreOrder
        }
        this.productBrand = data.productBrand
    }
}